// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1cO-J","buttons":"PendingPaymentAlert_buttons__37rrx"};